import { CSSObject } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export function getShipmentRowExtensionStyles(theme: Theme): CSSObject {
    return {
        margin: theme.spacing(1),
        boxShadow: theme.elevations.popout1.boxShadow,
        borderRadius: theme.borderRadius.M,
        backgroundColor: theme.palette.white,
    };
}
